import { Address, CreateAddress, UpdateAddress } from "../../../address/types/models/Address";
import { CuttingState } from "./CuttingState.d";
import { ShipmentState } from "./ShipmentState.d";
import { ShipmentType } from "./ShipmentType.d";
import { UserType } from "./UserType.d";
import { CordwoodMeasurementType } from "./CordwoodMeasurementType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity Contractors


export interface Contractor {
    id: ID;

    
    name: string;

    
    description?: string;

    
    vatId?: string;

    
    iban?: string;

    
    bank?: string;

    
    scopeGroupId: ID;

    
    swift?: string;

    
    contractorScopeGroupId: ID;

    
    addressIdAddress?: Address;
    

    }




export interface CreateContractor {
    
    name: string;

    
    description?: string;

    
    vatId?: string;

    
    iban?: string;

    
    bank?: string;

    
    
    swift?: string;

    
    
    addressIdAddress?: CreateAddress;
    

    }


export interface UpdateContractor {
    
    name: string;

    
    description?: string;

    
    vatId?: string;

    
    iban?: string;

    
    bank?: string;

    
    
    swift?: string;

    
    
    addressIdAddress?: UpdateAddress;
    

    }

export interface PresentationContractorRequest {
    list: ListRequest,
    filter: {
        name: string,
        nameOr: boolean,
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryContractor {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: Contractor): PrimaryContractor | undefined {
        return entity ? new PrimaryContractor(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryContractor {
        return new PrimaryContractor(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryContractor {
        let vals = path?.split('/');
        return new PrimaryContractor(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryContractor[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: Contractor): string {
    let fields = entity ? [
    entity.name,
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityContractor {
    id: PrimaryContractor;
    data: UpdateContractor;


    constructor(id: PrimaryContractor, data: UpdateContractor) {
        this.id = id;
        this.data = data;
    }
}
